import React from 'react';
import Text from '../Text';

const Heading = ({ level = 2, ...restProps }) => {
  return <Text as={`h${level}`} display="block" {...restProps} />;
};

export default Heading;
